import React from 'react';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { useWatchlist } from '../context/WatchlistContext';
import './WatchlistStar.css';

const WatchlistStar = ({ stock, size = '16px' }) => {
  const { isInWatchlist, addToWatchlist, removeFromWatchlist } = useWatchlist();
  const inWatchlist = isInWatchlist(stock.symbol);

  const handleClick = (e) => {
    e.stopPropagation();
    if (inWatchlist) {
      removeFromWatchlist(stock.symbol);
    } else {
      addToWatchlist(stock);
    }
  };

  return (
    <button
      className={`watchlist-star ${inWatchlist ? 'active' : ''}`}
      onClick={handleClick}
      title={inWatchlist ? 'Remove from watchlist' : 'Add to watchlist'}
      style={{ fontSize: size }}
    >
      {inWatchlist ? (
        <FaStar className="star-icon filled" />
      ) : (
        <FaRegStar className="star-icon empty" />
      )}
    </button>
  );
};

export default WatchlistStar;
